import React, { Component } from 'react'
import { connect } from 'react-redux'
import { TransitionGroup } from 'react-transition-group'
import _ from 'lodash'
import {Spinner} from'../images/Spinner';
import {Logo} from'../images/Logo';
import { withRouter } from 'react-router'

import { FadeAbsoluteLoader } from './Transitions'

class Loader extends Component {
    render() {
    	const { loading, location } = this.props
        const isLoading = _.find(loading, (val) => val)
        return (
            <TransitionGroup>
                {isLoading && _.isEmpty(location.hash) && 
                    <FadeAbsoluteLoader>
                        <div className="loading with-logo">
                            <div className="logo"><Logo/></div>
                            <div className="loader"><Spinner/></div>
                        </div>
                    </FadeAbsoluteLoader>
                }
            </TransitionGroup>
		)
    }
}
function mapStateToProps(state) {
    const loader = state.loader || false
    return {
        loading: loader,
    }
}

export default withRouter(connect(mapStateToProps)(Loader))


// WEBPACK FOOTER //
// ./src/components/Loader.js